<template>
  <v-layout row wrap>
    <v-flex xs12 class="px-0">
      <v-card flat color="transparent">
        <slot></slot>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'mv-page'
}
</script>

<style lang="css">
</style>
